import { Box, Button, DialogActions } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import CbButton from '../../../../../../../../../../components/Buttons/CbButton';
import { Flexbox } from '../../../../../../../../../../components/layout/Flexbox';

export const AddItemDialogActions = ({
  addLabel,
  onAdd,
  onCancel,
}: AddItemDialogActionsProps) => (
  <DialogActions>
    <Flexbox>
      <Button
        startIcon={<AddIcon style={{ pointerEvents: 'none' }} />}
        className="contrast-text"
        onClick={onAdd}
      >
        {addLabel}
      </Button>
      <Box>
        <CbButton onClick={onCancel} styleName="cancel">
          Cancel
        </CbButton>
        <CbButton type="submit" styleName="ctaButton">
          Save
        </CbButton>
      </Box>
    </Flexbox>
  </DialogActions>
);

type AddItemDialogActionsProps = Readonly<{
  addLabel: string;
  onAdd: () => void;
  onCancel: () => void;
}>;
